import { fetchJson2 } from 'helpers/api';

const fetchPurchaseOrderStatuses = () => fetchJson2('/api/purchase-orders/status');

export { fetchPurchaseOrderStatuses };
